export class GenderImageSwap extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()
    if (window.theme.genderFilter === 'men') {
      if (this.querySelector('.prd-Card_ImageContainer')) {
        if (
          this.querySelector('.prd-Card_ImageContainer').dataset
            .genderImages !== ''
        ) {
          this.querySelector('.prd-Card_ImageContainer').querySelector(
            'img',
          ).srcset = ''

          this.querySelector('.prd-Card_ImageContainer').querySelector(
            'img',
          ).src = this.querySelector(
            '.prd-Card_ImageContainer',
          ).dataset.genderImages.split(',')[0]

          if (
            this.querySelector(
              '.prd-Card_ImageContainer',
            ).dataset.genderImages.split(',')[1]
          ) {
            this.querySelector(
              '.prd-Card_SecondaryImageContainer',
            ).querySelector('img').srcset = ''

            this.querySelector(
              '.prd-Card_SecondaryImageContainer',
            ).querySelector('img').src = this.querySelector(
              '.prd-Card_ImageContainer',
            ).dataset.genderImages.split(',')[1]
          }
        }
      }

      if (this.parentNode.querySelector('.prd-Card_FauxLink')) {
        const link = new URL(
          this.parentNode.querySelector('.prd-Card_FauxLink').href,
        )
        link.search = link.search
          ? `${link.search}&gender=male`
          : `?gender=male`
        this.parentNode.querySelector('.prd-Card_FauxLink').href = link.href
      }
    }
  }
}

customElements.define('gender-image-swap', GenderImageSwap)
